import './ScreenManager_Single.scss';
import { ScreenManager } from '@components/Component/Container/ScreenManager/ScreenManager.js';
import { ScreenSingle } from '@components/Component/Container/Screen/ScreenSingle/ScreenSingle.js';
import { Form } from '@components/Component/Container/Form/Form.js';
import { getID, isMobile } from '@components/Utility/index.js';
import { ENV } from '@components/Environment.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
/**
 * `ScreenManager_Single` class is a subclass of `ScreenManager` that manages single page mode screen (just one screen).
 */
export class ScreenManager_Single extends ScreenManager {
    constructor() {
        super(...arguments);
        this.componentName = 'ScreenManager_Single';
    }
    /**
     * ScreenManager_Single is for Single screen apps so when you "open" a form or url, it will redirect the screen.
     * @param url
     * @param options
     */
    open(url, options) {
        if (options?.screenCover) {
            this.screen = super.open(url, options);
        }
        else if (!this.screen) {
            this.screen = super.open(url, options);
        }
        else {
            if (isMobile()) {
                DIContainer.getInstance('Application').componentGet('toolbar')?.propertySet('collapsed', true);
            }
            if (url instanceof Form) {
                this.screen.loadForm(url);
            }
            else {
                this.screen.navigate(url, options?.requestParams, { hash: options?.hash, delayUntilRefreshed: options?.delayUntilRefreshed });
            }
        }
        return this.screen;
    }
    draw() {
        super.draw();
        this.registerEvent('popstate', window, (event) => {
            this.open(location.href);
        });
    }
    screenRemove(id) {
        super.screenRemove(id);
        this.screen = undefined;
        if (ENV('appName') === 'q360') {
            const navbar = DIContainer.getInstance('Application').componentGet('navbar');
            navbar.buttonHiddenSet('rightmenu_screenmenu_btn', true);
        }
    }
    /**
     * The `screenCreate` method creates a new `ScreenSingle` instance, if a screen already exists it will just return that instance.
     *
     * @param screenGroupId - Optional. Not applicable to `ScreenSingle`
     *
     * @returns The created screen.
     */
    screenCreate(screenGroupId) {
        if (this.screen) {
            return this.screen;
        }
        let screenGroup = this.screenGroupGet(screenGroupId || '');
        if (!screenGroup) {
            screenGroup = this.activeScreenGroupGet();
        }
        const screenRoot = document.createElement('div');
        const screen = new ScreenSingle(getID('screen'), screenRoot, {}, screenGroup.id);
        screen.draw();
        this.screenAdd(screen);
        screenGroup.screenAdd(screen);
        if (ENV('appName') === 'q360') {
            const navbar = DIContainer.getInstance('Application').componentGet('navbar');
            navbar.buttonHiddenSet('rightmenu_screenmenu_btn', false);
        }
        return screen;
    }
}
ScreenManager_Single.VERSION = '$Revision: 111642 $';
